import { AppStore } from "@/store/AppStore";
import { DateTime } from "luxon";
import { ApiSchema } from "@/modules/api";

export type GatedFeatureConfigMap = Record<GatedFeature, GatedFeatureConfig>;
export type SerializableGatedFeatureConfigMap = Record<
  GatedFeature,
  Omit<GatedFeatureConfig, "counter">
>;
export type GatedFeatureConfigMapData = Record<GatedFeature, Omit<GatedFeatureConfig, "counter">>;

export interface GatedFeatureConfig {
  period: GatingPeriod;
  limits: Record<FeatureLimit, number | null>;
  counter: (ctx: GateUsageCounterContext) => number;
}

export type GatedFeature = ApiSchema["FeatureGateConfigSchema"]["feature"];
export const GatedFeature = {
  NoteCreate: "note.create" as GatedFeature,
  ChatMessageSend: "chat_message.send" as GatedFeature,
  DarkMode: "dark_mode" as GatedFeature,
} as const;

export type GatingPeriod = ApiSchema["FeatureGateConfigSchema"]["period"];
export const GatingPeriod = {
  Monthly: "monthly" as GatingPeriod,
} as const;

export type PlanId = ApiSchema["PlanId"];
export const PlanId = {
  Free: "free" as PlanId,
  Paid: "paid" as PlanId,
} as const;

export type FeatureLimit = keyof ApiSchema["FeatureLimitsSchema"];
export const FeatureLimit = {
  Free: "free" as FeatureLimit,
  Paid: "paid" as FeatureLimit,
  Warning: "warning" as FeatureLimit,
} as const;

export interface GateUsageCounterContext {
  store: AppStore;
  periodStart: DateTime;
  periodEnd: DateTime;
}

export type GateUsage = {
  allowed: boolean;
  used: number;
  limit: number;
};
